export default "__VITE_ASSET__DqqfCq70__"